module.exports = __webpack_public_path__ + "img/puzzle_6.6cd7331b.png";